import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { svgElement } from 'src/dictionaries/svg-sign';
import { ComplementInformationEnum, ComplementInformationSignEnum, SignalingTypeEnum, VerticalSignalizationTypeEnum } from 'src/enumerators';

@Component({
  selector: 'app-sign-svg',
  templateUrl: './sign-svg.component.html',
  styleUrls: ['./sign-svg.component.css']
})
export class SignSvgComponent implements OnInit, OnChanges {

  @Input() width;
  @Input() height;
  @Input() sign;
  @Input() index;
  @Input() contrast = false;

  signalingTypeEnum = SignalingTypeEnum;
  verticalSignTypeEnum = VerticalSignalizationTypeEnum;
  complementInformationType = ComplementInformationEnum;

  constructor() { }

  ngOnInit() {
    if (this.sign.type == SignalingTypeEnum.Vertical)
      this.sign['svg'] = this.sign?.trafficSigns?.length
        ? svgElement.Signaling[this.sign?.trafficSigns[this.index]?.signCode]
        : svgElement.Signaling[this.sign.signCode];
    else
      this.sign['svg'] = svgElement.Signaling[this.sign.signCode];
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (changes?.index) {
      if (this.sign.type == SignalingTypeEnum.Vertical)
        this.sign['svg'] = this.sign.trafficSigns[this.index]?.signCode ? svgElement.Signaling[this.sign.trafficSigns[this.index]?.signCode] : svgElement.Signaling[this.sign.verticalCode];
      else
        this.sign['svg'] = svgElement.Signaling[this.sign.signCode];
    }
    if (changes?.contrast) {
      this.contrast = changes.contrast.currentValue;
    }
  }


  complementType(): ComplementInformationSignEnum {
    if (this.sign.complementInformationType == ComplementInformationEnum.Additional) {
      if (this.sign.verticalType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.AdditionalWarning;
      } else {
        return ComplementInformationSignEnum.AdditionalRegulation;
      }
    } else {
      if (this.sign.verticalType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.IncorporatedWarning;
      } else {
        return ComplementInformationSignEnum.IncorporatedRegulation;
      }
    }
  }
}
